import { useState } from "react";

const PLANOS = [
  { id:"starter", nome:"Starter", preco:99, cor:"#3B82F6", limite:"500 clientes", modulos:["Clientes","Financeiro","Relatórios"] },
  { id:"pro", nome:"Pro", preco:199, cor:"#8B5CF6", limite:"5.000 clientes", modulos:["Clientes","Financeiro","Contratos","Estoque","Relatórios"], popular:true },
  { id:"enterprise", nome:"Enterprise", preco:399, cor:"#F59E0B", limite:"Ilimitado", modulos:["Todos os módulos","Multi-usuários","API","Suporte prioritário"] },
];
const TENANTS_INIT = [
  { id:"T001", empresa:"Provitel Internet", cnpj:"12.345.678/0001-90", plano:"pro", status:"ativo", clientes:342, mrr:199 },
  { id:"T002", empresa:"NetFibra Telecom", cnpj:"98.765.432/0001-11", plano:"enterprise", status:"ativo", clientes:1840, mrr:399 },
  { id:"T003", empresa:"AlphaNet Soluções", cnpj:"45.678.901/0001-22", plano:"starter", status:"trial", clientes:88, mrr:0 },
];
const CLIENTES_INIT = [
  { id:"C001", nome:"João Silva", doc:"123.456.789-00", email:"joao@email.com", tel:"(15)99999-1111", cidade:"Sorocaba", ativo:true, plano:"Fibra 300MB", venc:"10/07/2026" },
  { id:"C002", nome:"Maria Souza", doc:"987.654.321-00", email:"maria@email.com", tel:"(15)98888-2222", cidade:"Sorocaba", ativo:true, plano:"Fibra 500MB", venc:"15/07/2026" },
  { id:"C003", nome:"Pedro Alves LTDA", doc:"12.345.678/0001-90", email:"pedro@empresa.com", tel:"(15)97777-3333", cidade:"Votorantim", ativo:false, plano:"Fibra 1GB", venc:"01/06/2026" },
  { id:"C004", nome:"Ana Costa", doc:"456.789.012-00", email:"ana@email.com", tel:"(15)96666-4444", cidade:"Sorocaba", ativo:true, plano:"Fibra 100MB", venc:"20/07/2026" },
  { id:"C005", nome:"Carlos Ferreira", doc:"789.012.345-00", email:"carlos@email.com", tel:"(15)95555-5555", cidade:"Itu", ativo:true, plano:"Fibra 300MB", venc:"08/07/2026" },
];
const CR_INIT = [
  { id:"CR001", desc:"Mensalidade Fibra 300MB", cliente:"João Silva", valor:89.90, venc:"10/07/2026", status:"aberto" },
  { id:"CR002", desc:"Mensalidade Fibra 500MB", cliente:"Maria Souza", valor:119.90, venc:"15/07/2026", status:"aberto" },
  { id:"CR003", desc:"Mensalidade Fibra 1GB", cliente:"Pedro Alves LTDA", valor:199.90, venc:"01/06/2026", status:"atrasado" },
  { id:"CR004", desc:"Instalação + Equipamento", cliente:"Ana Costa", valor:250.00, venc:"01/07/2026", status:"pago" },
  { id:"CR005", desc:"Mensalidade Fibra 100MB", cliente:"Ana Costa", valor:59.90, venc:"20/07/2026", status:"aberto" },
];
const CONTRATOS_INIT = [
  { id:"CT001", numero:"CTR-2026-001", cliente:"João Silva", plano:"Fibra 300MB", valor:89.90, inicio:"01/01/2026", fim:"31/12/2026", venc_dia:10, status:"ativo", obs:"Contrato residencial" },
  { id:"CT002", numero:"CTR-2026-002", cliente:"Maria Souza", plano:"Fibra 500MB", valor:119.90, inicio:"01/02/2026", fim:"31/01/2027", venc_dia:15, status:"ativo", obs:"" },
  { id:"CT003", numero:"CTR-2026-003", cliente:"Pedro Alves LTDA", plano:"Fibra 1GB", valor:199.90, inicio:"01/03/2026", fim:"28/02/2027", venc_dia:1, status:"suspenso", obs:"Inadimplente" },
  { id:"CT004", numero:"CTR-2026-004", cliente:"Ana Costa", plano:"Fibra 100MB", valor:59.90, inicio:"15/04/2026", fim:"14/04/2027", venc_dia:20, status:"ativo", obs:"" },
];
const ESTOQUE_INIT = [
  { id:"E001", codigo:"ONU-001", nome:"ONU ZTE F601", categoria:"Equipamentos", unidade:"UN", estoque:45, minimo:10, custo:85.00, preco:150.00 },
  { id:"E002", codigo:"CBL-001", nome:"Cabo Fibra Óptica 1m", categoria:"Cabos", unidade:"MT", estoque:520, minimo:100, custo:2.50, preco:5.00 },
  { id:"E003", codigo:"EQP-001", nome:"Roteador Wi-Fi AC1200", categoria:"Equipamentos", unidade:"UN", estoque:12, minimo:5, custo:120.00, preco:220.00 },
  { id:"E004", codigo:"EQP-002", nome:"Switch 8 Portas", categoria:"Equipamentos", unidade:"UN", estoque:3, minimo:5, custo:180.00, preco:320.00 },
  { id:"E005", codigo:"FER-001", nome:"Fusionadora de Fibra", categoria:"Ferramentas", unidade:"UN", estoque:2, minimo:1, custo:1800.00, preco:2500.00 },
  { id:"E006", codigo:"CBL-002", nome:"Cordão Óptico SC/APC", categoria:"Cabos", unidade:"UN", estoque:80, minimo:20, custo:8.00, preco:18.00 },
];
const MOV_ESTOQUE_INIT = [
  { id:"ME001", data:"10/06/2026", produto:"ONU ZTE F601", tipo:"saida", qtd:2, motivo:"Instalação cliente João Silva", resp:"Carlos" },
  { id:"ME002", data:"11/06/2026", produto:"Cabo Fibra Óptica 1m", tipo:"entrada", qtd:200, motivo:"Compra fornecedor", resp:"Admin" },
  { id:"ME003", data:"12/06/2026", produto:"Roteador Wi-Fi AC1200", tipo:"saida", qtd:1, motivo:"Instalação cliente Maria Souza", resp:"Pedro" },
  { id:"ME004", data:"13/06/2026", produto:"Switch 8 Portas", tipo:"saida", qtd:2, motivo:"Expansão rack servidor", resp:"Carlos" },
];
const FROTA_INIT = [
  { id:"V001", placa:"ABC-1234", modelo:"Fiat Strada", ano:2022, cor:"Branca", km:48500, status:"disponivel", motorista:"Carlos", venc_cnh:"15/08/2027", venc_seguro:"30/09/2026", venc_ipva:"31/03/2027" },
  { id:"V002", placa:"DEF-5678", modelo:"Volkswagen Gol", ano:2020, cor:"Prata", km:72300, status:"em_uso", motorista:"Pedro", venc_cnh:"22/11/2026", venc_seguro:"15/07/2026", venc_ipva:"28/02/2027" },
  { id:"V003", placa:"GHI-9012", modelo:"Chevrolet S10", ano:2021, cor:"Preta", km:35200, status:"manutencao", motorista:"", venc_cnh:"", venc_seguro:"01/12/2026", venc_ipva:"31/01/2027" },
];
const MANUT_INIT = [
  { id:"M001", veiculo:"ABC-1234 Fiat Strada", tipo:"Preventiva", data:"05/06/2026", km:48000, custo:450.00, oficina:"Auto Center Silva", obs:"Troca de óleo + filtros" },
  { id:"M002", veiculo:"GHI-9012 Chevrolet S10", tipo:"Corretiva", data:"10/06/2026", km:35200, custo:1200.00, oficina:"Mecânica do João", obs:"Correia dentada quebrada" },
  { id:"M003", veiculo:"DEF-5678 Volkswagen Gol", tipo:"Preventiva", data:"01/06/2026", km:72000, custo:380.00, oficina:"Auto Center Silva", obs:"Troca de pastilhas de freio" },
];

const fmt = v => new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(v);
const COR = {ativo:"#10B981",trial:"#F59E0B",suspenso:"#EF4444",pago:"#10B981",aberto:"#3B82F6",atrasado:"#EF4444",disponivel:"#10B981",em_uso:"#3B82F6",manutencao:"#F59E0B",encerrado:"#6B7280",entrada:"#10B981",saida:"#EF4444"};
const LAB = {ativo:"Ativo",trial:"Trial",suspenso:"Suspenso",pago:"Pago",aberto:"Aberto",atrasado:"Atrasado",disponivel:"Disponível",em_uso:"Em uso",manutencao:"Manutenção",encerrado:"Encerrado",entrada:"Entrada",saida:"Saída"};
const cor = s => COR[s]||"#6B7280";

const S = {
  page:{background:"#0F172A",minHeight:"100vh",color:"#F1F5F9",fontFamily:"system-ui,sans-serif"},
  card:{background:"#1E293B",borderRadius:12,padding:18,border:"1px solid #334155"},
  th:{textAlign:"left",padding:"7px 10px",color:"#64748B",fontSize:11,fontWeight:600},
  td:{padding:"10px",fontSize:13},
  sidebar:{width:210,background:"#0A1628",borderRight:"1px solid #1E293B",display:"flex",flexDirection:"column"},
  nav:{display:"flex",alignItems:"center",gap:9,padding:"9px 11px",borderRadius:7,marginBottom:2,cursor:"pointer",fontSize:13},
  inp:{width:"100%",background:"#0F172A",border:"1px solid #334155",borderRadius:7,padding:"8px 10px",color:"#F1F5F9",fontSize:13,boxSizing:"border-box"},
};

const Badge = ({status}) => <span style={{background:cor(status)+"22",color:cor(status),padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{LAB[status]||status}</span>;
const Btn = ({children,onClick,c="#3B82F6",out,sm,full,style={}}) => <button onClick={onClick} style={{background:out?"transparent":c,color:out?c:"#fff",border:`1px solid ${c}`,borderRadius:7,padding:sm?"5px 12px":"9px 18px",fontSize:sm?12:13,fontWeight:600,cursor:"pointer",width:full?"100%":"auto",...style}}>{children}</button>;
const Card = ({children,style={}}) => <div style={{...S.card,...style}}>{children}</div>;
const Metric = ({label,valor,sub,c="#3B82F6",icon}) => (
  <Card>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
      <div>
        <div style={{color:"#94A3B8",fontSize:12,marginBottom:4}}>{label}</div>
        <div style={{color:"#F1F5F9",fontSize:24,fontWeight:700}}>{valor}</div>
        {sub&&<div style={{color:"#64748B",fontSize:11,marginTop:3}}>{sub}</div>}
      </div>
      <div style={{width:38,height:38,borderRadius:9,background:c+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{icon}</div>
    </div>
  </Card>
);
const Logo = () => (
  <div style={{display:"flex",alignItems:"center",gap:10}}>
    <div style={{width:32,height:32,background:"linear-gradient(135deg,#3B82F6,#8B5CF6)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#fff",fontSize:15}}>M</div>
    <span style={{fontWeight:700,fontSize:16}}>MultiERP <span style={{color:"#3B82F6"}}>Pro</span></span>
  </div>
);
const Modal = ({title,children,onClose}) => (
  <Card style={{marginBottom:20,borderColor:"#3B82F6",borderWidth:2}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
      <div style={{fontWeight:700,fontSize:15}}>{title}</div>
      <Btn sm out c="#EF4444" onClick={onClose}>✕ Fechar</Btn>
    </div>
    {children}
  </Card>
);
const Campo = ({label,value,onChange,type="text",options}) => (
  <div>
    <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>{label}</label>
    {options
      ? <select value={value} onChange={e=>onChange(e.target.value)} style={S.inp}>{options.map(o=><option key={o} value={o}>{o}</option>)}</select>
      : <input value={value} onChange={e=>onChange(e.target.value)} type={type} style={S.inp}/>}
  </div>
);

// ── LANDING ──────────────────────────────────────────────────────────────────
function Landing({onGo}) {
  return (
    <div style={S.page}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"18px 48px",borderBottom:"1px solid #1E293B"}}>
        <Logo/>
        <div style={{display:"flex",gap:10}}>
          <Btn out onClick={onGo}>Entrar</Btn>
          <Btn onClick={onGo}>Começar grátis</Btn>
        </div>
      </div>
      <div style={{textAlign:"center",padding:"70px 48px 50px"}}>
        <div style={{display:"inline-block",background:"#3B82F622",color:"#3B82F6",padding:"5px 14px",borderRadius:20,fontSize:12,fontWeight:600,marginBottom:22}}>✦ ERP completo · Qualquer segmento</div>
        <h1 style={{fontSize:48,fontWeight:800,lineHeight:1.1,maxWidth:640,margin:"0 auto 18px"}}>
          Gerencie sua empresa com{" "}
          <span style={{background:"linear-gradient(90deg,#3B82F6,#8B5CF6)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>inteligência</span>
        </h1>
        <p style={{color:"#94A3B8",fontSize:17,maxWidth:520,margin:"0 auto 36px",lineHeight:1.6}}>Clientes, financeiro, estoque, frota e contratos em um único sistema. Simples, rápido e moderno.</p>
        <div style={{display:"flex",gap:14,justifyContent:"center"}}>
          <Btn onClick={onGo} style={{padding:"13px 30px",fontSize:15}}>Testar 14 dias grátis</Btn>
          <Btn out onClick={onGo} c="#94A3B8" style={{padding:"13px 30px",fontSize:15}}>Ver demonstração</Btn>
        </div>
        <p style={{color:"#475569",fontSize:12,marginTop:14}}>Sem cartão de crédito · Cancele quando quiser</p>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,maxWidth:900,margin:"0 auto",padding:"0 48px 40px"}}>
        {[["👥","Clientes","Cadastro completo com histórico e documentos."],
          ["💰","Financeiro","Contas a receber, pagar e fluxo de caixa."],
          ["📋","Contratos","Vencimentos e renovações automáticas."],
          ["📦","Estoque","Entradas/saídas com alertas de mínimo."],
          ["🚗","Frota","Veículos, manutenções e abastecimentos."],
          ["📊","Relatórios","Dashboards em tempo real + exportação."]
        ].map(([ic,t,d])=>(
          <Card key={t}>
            <div style={{fontSize:26,marginBottom:10}}>{ic}</div>
            <div style={{fontWeight:700,marginBottom:6,fontSize:14}}>{t}</div>
            <div style={{color:"#94A3B8",fontSize:13,lineHeight:1.5}}>{d}</div>
          </Card>
        ))}
      </div>
      <div style={{padding:"40px 48px",textAlign:"center"}}>
        <h2 style={{fontSize:30,fontWeight:800,marginBottom:8}}>Planos e preços</h2>
        <p style={{color:"#94A3B8",marginBottom:32}}>Escolha o plano ideal para seu negócio</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18,maxWidth:860,margin:"0 auto"}}>
          {PLANOS.map(p=>(
            <div key={p.id} style={{background:p.popular?"linear-gradient(135deg,#1E3A5F,#2D1B69)":"#1E293B",border:`2px solid ${p.popular?p.cor:"#334155"}`,borderRadius:14,padding:26,position:"relative"}}>
              {p.popular&&<div style={{position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:p.cor,color:"#fff",fontSize:11,fontWeight:700,padding:"3px 14px",borderRadius:20}}>MAIS POPULAR</div>}
              <div style={{color:p.cor,fontWeight:700,fontSize:13,marginBottom:6}}>{p.nome}</div>
              <div style={{fontSize:34,fontWeight:800,marginBottom:3}}>R$ {p.preco}<span style={{fontSize:13,color:"#94A3B8"}}>/mês</span></div>
              <div style={{color:"#64748B",fontSize:12,marginBottom:18}}>{p.limite}</div>
              {p.modulos.map(m=><div key={m} style={{color:"#94A3B8",fontSize:13,padding:"3px 0"}}>✓ {m}</div>)}
              <Btn onClick={onGo} c={p.cor} full style={{marginTop:20,padding:"11px 0"}}>Começar</Btn>
            </div>
          ))}
        </div>
      </div>
      <div style={{textAlign:"center",padding:14,color:"#334155",fontSize:12,borderTop:"1px solid #1E293B"}}>© 2026 MultiERP Pro · Next Networks · erp.nextnetworking.com.br</div>
    </div>
  );
}

// ── LOGIN ────────────────────────────────────────────────────────────────────
function Login({onLogin}) {
  const [modo,setModo] = useState("admin");
  return (
    <div style={{...S.page,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{width:380}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{width:48,height:48,background:"linear-gradient(135deg,#3B82F6,#8B5CF6)",borderRadius:11,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:20,margin:"0 auto 14px",color:"#fff"}}>M</div>
          <div style={{fontWeight:700,fontSize:20}}>MultiERP <span style={{color:"#3B82F6"}}>Pro</span></div>
          <div style={{color:"#64748B",fontSize:13,marginTop:3}}>Acesse sua conta</div>
        </div>
        <div style={{display:"flex",gap:6,marginBottom:20,background:"#1E293B",padding:4,borderRadius:10}}>
          {["admin","tenant"].map(m=>(
            <button key={m} onClick={()=>setModo(m)} style={{flex:1,padding:"8px",borderRadius:7,border:"none",background:modo===m?"#3B82F6":"transparent",color:modo===m?"#fff":"#64748B",fontWeight:600,fontSize:12,cursor:"pointer"}}>
              {m==="admin"?"🛡️ Admin Geral":"🏢 Empresa"}
            </button>
          ))}
        </div>
        <Card>
          {[["Email",modo==="admin"?"admin@nextnetworking.com.br":"empresa@cliente.com","text"],["Senha","••••••••","password"]].map(([l,v,t])=>(
            <div key={l} style={{marginBottom:14}}>
              <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:5}}>{l}</label>
              <input defaultValue={v} type={t} style={S.inp}/>
            </div>
          ))}
          <Btn onClick={()=>onLogin(modo)} full style={{padding:"11px 0",fontSize:14,marginTop:4}}>Entrar</Btn>
        </Card>
        <div style={{textAlign:"center",marginTop:14,color:"#475569",fontSize:12}}>
          Sem conta? <span onClick={()=>onLogin("tenant")} style={{color:"#3B82F6",cursor:"pointer"}}>Criar trial grátis</span>
        </div>
      </div>
    </div>
  );
}

// ── ADMIN ────────────────────────────────────────────────────────────────────
function Admin({onLogout,onTenant}) {
  const [aba,setAba] = useState("dashboard");
  const [tenants,setTenants] = useState(TENANTS_INIT);
  const [showModal,setShowModal] = useState(false);
  const [novo,setNovo] = useState({empresa:"",cnpj:"",plano:"starter",email:"",resp:""});
  const mrr = tenants.filter(t=>t.status==="ativo").reduce((a,t)=>a+t.mrr,0);
  const MENUS=[["dashboard","📊","Dashboard"],["tenants","🏢","Empresas"],["planos","💳","Planos"],["financeiro","💰","Financeiro"],["config","⚙️","Config"]];

  const cadastrar = () => {
    if(!novo.empresa||!novo.cnpj) return;
    setTenants(p=>[...p,{id:"T"+Date.now(),empresa:novo.empresa,cnpj:novo.cnpj,plano:novo.plano,status:"trial",clientes:0,mrr:0}]);
    setNovo({empresa:"",cnpj:"",plano:"starter",email:"",resp:""});
    setShowModal(false);
  };

  return (
    <div style={{display:"flex",height:"100vh",...S.page}}>
      <div style={S.sidebar}>
        <div style={{padding:"16px 14px",borderBottom:"1px solid #1E293B"}}><Logo/><div style={{color:"#3B82F6",fontSize:11,marginTop:4}}>🛡️ Admin Geral</div></div>
        <nav style={{flex:1,padding:"10px 7px"}}>
          {MENUS.map(([id,ic,lb])=>(
            <div key={id} onClick={()=>setAba(id)} style={{...S.nav,background:aba===id?"#1E3A5F":"transparent",color:aba===id?"#3B82F6":"#94A3B8",fontWeight:aba===id?600:400}}>{ic} {lb}</div>
          ))}
        </nav>
        <div style={{padding:"10px 7px",borderTop:"1px solid #1E293B"}}>
          <div onClick={onLogout} style={{...S.nav,color:"#EF4444"}}>🚪 Sair</div>
        </div>
      </div>
      <div style={{flex:1,overflow:"auto",padding:24}}>
        {aba==="dashboard"&&(
          <div>
            <h1 style={{fontSize:22,fontWeight:800,marginBottom:4}}>Dashboard Geral</h1>
            <div style={{color:"#64748B",fontSize:13,marginBottom:20}}>Visão geral dos tenants</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
              <Metric label="MRR" valor={fmt(mrr)} sub="+12% este mês" c="#10B981" icon="💰"/>
              <Metric label="Tenants ativos" valor={tenants.filter(t=>t.status==="ativo").length} sub={tenants.filter(t=>t.status==="trial").length+" em trial"} c="#3B82F6" icon="🏢"/>
              <Metric label="Total empresas" valor={tenants.length} c="#8B5CF6" icon="📋"/>
              <Metric label="ARR projetado" valor={fmt(mrr*12)} sub="Receita anual" c="#F59E0B" icon="📈"/>
            </div>
            <Card>
              <div style={{fontWeight:700,marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span>Empresas cadastradas</span>
                <Btn sm onClick={()=>setAba("tenants")}>Ver todas</Btn>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Empresa","Plano","Clientes","Status","MRR",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {tenants.map(t=>(
                    <tr key={t.id} style={{borderBottom:"1px solid #1E293B"}}>
                      <td style={{...S.td,fontWeight:600}}>{t.empresa}</td>
                      <td style={S.td}><span style={{textTransform:"capitalize",color:PLANOS.find(p=>p.id===t.plano)?.cor,fontSize:12}}>{t.plano}</span></td>
                      <td style={{...S.td,color:"#94A3B8"}}>{t.clientes.toLocaleString("pt-BR")}</td>
                      <td style={S.td}><Badge status={t.status}/></td>
                      <td style={{...S.td,fontWeight:700,color:t.mrr>0?"#10B981":"#475569"}}>{t.mrr>0?fmt(t.mrr):"Trial"}</td>
                      <td style={S.td}><Btn sm onClick={()=>onTenant(t)}>Acessar</Btn></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          </div>
        )}
        {aba==="tenants"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:22,fontWeight:800}}>Empresas</h1><div style={{color:"#64748B",fontSize:13}}>{tenants.length} cadastradas</div></div>
              <Btn onClick={()=>setShowModal(true)}>+ Nova empresa</Btn>
            </div>
            {showModal&&(
              <Modal title="Cadastrar nova empresa" onClose={()=>setShowModal(false)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  {[["Razão Social","empresa"],["CNPJ","cnpj"],["Email","email"],["Responsável","resp"]].map(([l,k])=>(
                    <Campo key={k} label={l} value={novo[k]} onChange={v=>setNovo(p=>({...p,[k]:v}))}/>
                  ))}
                  <div>
                    <label style={{color:"#94A3B8",fontSize:12,display:"block",marginBottom:4}}>Plano</label>
                    <select value={novo.plano} onChange={e=>setNovo(p=>({...p,plano:e.target.value}))} style={S.inp}>
                      {PLANOS.map(p=><option key={p.id} value={p.id}>{p.nome} — R$ {p.preco}/mês</option>)}
                    </select>
                  </div>
                </div>
                <Btn onClick={cadastrar} c="#10B981">✓ Cadastrar (trial 14 dias)</Btn>
              </Modal>
            )}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {tenants.map(t=>(
                <Card key={t.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div style={{display:"flex",alignItems:"center",gap:14}}>
                    <div style={{width:40,height:40,background:(PLANOS.find(p=>p.id===t.plano)?.cor||"#3B82F6")+"22",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:17,color:PLANOS.find(p=>p.id===t.plano)?.cor}}>{t.empresa[0]}</div>
                    <div>
                      <div style={{fontWeight:700,fontSize:14}}>{t.empresa}</div>
                      <div style={{color:"#64748B",fontSize:12}}>{t.cnpj} · {t.clientes.toLocaleString("pt-BR")} clientes</div>
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:14}}>
                    <span style={{color:PLANOS.find(p=>p.id===t.plano)?.cor,fontWeight:600,fontSize:12,textTransform:"capitalize"}}>{t.plano}</span>
                    <Badge status={t.status}/>
                    <span style={{color:t.mrr>0?"#10B981":"#475569",fontWeight:700,fontSize:13}}>{t.mrr>0?fmt(t.mrr)+"/mês":"Trial"}</span>
                    <Btn sm onClick={()=>onTenant(t)}>Acessar ERP</Btn>
                    <Btn sm out c="#EF4444" onClick={()=>setTenants(prev=>prev.map(x=>x.id===t.id?{...x,status:x.status==="ativo"?"suspenso":"ativo"}:x))}>{t.status==="ativo"?"Suspender":"Ativar"}</Btn>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}
        {aba==="planos"&&(
          <div>
            <h1 style={{fontSize:22,fontWeight:800,marginBottom:20}}>Planos</h1>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18}}>
              {PLANOS.map(p=>(
                <Card key={p.id} style={{borderColor:p.popular?p.cor:"#334155",borderWidth:p.popular?2:1}}>
                  <div style={{color:p.cor,fontWeight:700,fontSize:15,marginBottom:6}}>{p.nome}</div>
                  <div style={{fontSize:30,fontWeight:800,marginBottom:3}}>R$ {p.preco}<span style={{fontSize:13,color:"#94A3B8"}}>/mês</span></div>
                  <div style={{color:"#64748B",marginBottom:14,fontSize:12}}>{p.limite}</div>
                  {p.modulos.map(m=><div key={m} style={{color:"#94A3B8",fontSize:12,padding:"2px 0"}}>✓ {m}</div>)}
                  <div style={{marginTop:14,display:"flex",gap:10,alignItems:"center"}}>
                    <Btn sm c={p.cor}>Editar</Btn>
                    <span style={{color:"#64748B",fontSize:12}}>{tenants.filter(t=>t.plano===p.id).length} empresa(s)</span>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        )}
        {aba==="financeiro"&&(
          <div>
            <h1 style={{fontSize:22,fontWeight:800,marginBottom:20}}>Financeiro SaaS</h1>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
              <Metric label="MRR" valor={fmt(mrr)} sub="Receita mensal" c="#10B981" icon="💰"/>
              <Metric label="ARR" valor={fmt(mrr*12)} sub="Projeção anual" c="#3B82F6" icon="📈"/>
              <Metric label="Trials" valor={tenants.filter(t=>t.status==="trial").length} sub="Convertendo" c="#F59E0B" icon="⏳"/>
            </div>
            <Card>
              <div style={{fontWeight:700,marginBottom:14}}>Receita por tenant</div>
              {tenants.filter(t=>t.mrr>0).map(t=>(
                <div key={t.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #1E293B"}}>
                  <span style={{color:"#94A3B8",fontSize:13}}>{t.empresa}</span>
                  <div style={{display:"flex",gap:14,alignItems:"center"}}>
                    <Badge status={t.status}/>
                    <span style={{color:"#10B981",fontWeight:700,fontSize:13}}>{fmt(t.mrr)}/mês</span>
                  </div>
                </div>
              ))}
              <div style={{marginTop:14,padding:"10px 0",display:"flex",justifyContent:"space-between"}}>
                <span style={{fontWeight:700}}>Total MRR</span>
                <span style={{color:"#10B981",fontWeight:800,fontSize:16}}>{fmt(mrr)}</span>
              </div>
            </Card>
          </div>
        )}
        {aba==="config"&&(
          <div>
            <h1 style={{fontSize:22,fontWeight:800,marginBottom:20}}>Configurações</h1>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>Dados da plataforma</div>
                {[["Nome","MultiERP Pro"],["Domínio","erp.nextnetworking.com.br"],["Suporte","suporte@nextnetworking.com.br"],["CNPJ","48.532.377/0001-18"]].map(([k,v])=>(
                  <div key={k} style={{marginBottom:10}}><div style={{color:"#64748B",fontSize:11}}>{k}</div><div style={{color:"#F1F5F9",fontSize:13}}>{v}</div></div>
                ))}
              </Card>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>Integrações</div>
                {[["WhatsApp (Evolution API)","conectado","#10B981"],["Email SMTP","configurar","#F59E0B"],["Stripe / PagSeguro","configurar","#F59E0B"],["Webhooks","desativado","#EF4444"]].map(([n,s,c])=>(
                  <div key={n} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #1E293B"}}>
                    <span style={{fontSize:13}}>{n}</span><span style={{color:c,fontSize:11,fontWeight:700}}>{s}</span>
                  </div>
                ))}
              </Card>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── TENANT ERP ────────────────────────────────────────────────────────────────
function TenantERP({tenant,onBack}) {
  const [aba,setAba] = useState("dashboard");
  const [clientes,setClientes] = useState(CLIENTES_INIT);
  const [cr,setCr] = useState(CR_INIT);
  const [contratos,setContratos] = useState(CONTRATOS_INIT);
  const [estoque,setEstoque] = useState(ESTOQUE_INIT);
  const [movs,setMovs] = useState(MOV_ESTOQUE_INIT);
  const [frota,setFrota] = useState(FROTA_INIT);
  const [manut,setManut] = useState(MANUT_INIT);
  const [modal,setModal] = useState(null);
  const [form,setForm] = useState({});

  const ativos = clientes.filter(c=>c.ativo).length;
  const rec_ab = cr.filter(x=>x.status==="aberto").reduce((a,x)=>a+x.valor,0);
  const rec_at = cr.filter(x=>x.status==="atrasado").reduce((a,x)=>a+x.valor,0);
  const rec_pg = cr.filter(x=>x.status==="pago").reduce((a,x)=>a+x.valor,0);
  const ct_ativos = contratos.filter(c=>c.status==="ativo").length;
  const est_baixo = estoque.filter(e=>e.estoque<=e.minimo).length;
  const vei_disp = frota.filter(v=>v.status==="disponivel").length;

  const MENUS=[["dashboard","📊","Dashboard"],["clientes","👥","Clientes"],["financeiro","💰","Financeiro"],["contratos","📋","Contratos"],["estoque","📦","Estoque"],["frota","🚗","Frota"],["relatorios","📈","Relatórios"],["usuarios","👤","Usuários"]];

  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  const salvar = {
    cliente: () => { if(!form.nome) return; setClientes(p=>[...p,{id:"C"+Date.now(),...form,ativo:true}]); setModal(null); setForm({}); },
    lancamento: () => { if(!form.desc||!form.valor) return; setCr(p=>[...p,{id:"CR"+Date.now(),desc:form.desc,cliente:form.cliente||"",valor:parseFloat(form.valor),venc:form.venc||"",status:"aberto"}]); setModal(null); setForm({}); },
    contrato: () => { if(!form.cliente||!form.plano) return; const n=contratos.length+1; setContratos(p=>[...p,{id:"CT"+Date.now(),numero:`CTR-2026-${String(n+4).padStart(3,"0")}`,cliente:form.cliente,plano:form.plano,valor:parseFloat(form.valor||0),inicio:form.inicio||"",fim:form.fim||"",venc_dia:parseInt(form.venc_dia||10),status:"ativo",obs:form.obs||""}]); setModal(null); setForm({}); },
    estoque_mov: () => { if(!form.produto||!form.qtd) return; const delta=form.tipo==="entrada"?parseInt(form.qtd):-parseInt(form.qtd); setEstoque(p=>p.map(e=>e.nome===form.produto?{...e,estoque:Math.max(0,e.estoque+delta)}:e)); setMovs(p=>[{id:"ME"+Date.now(),data:new Date().toLocaleDateString("pt-BR"),produto:form.produto,tipo:form.tipo||"entrada",qtd:parseInt(form.qtd),motivo:form.motivo||"",resp:form.resp||""},...p]); setModal(null); setForm({}); },
    veiculo: () => { if(!form.placa||!form.modelo) return; setFrota(p=>[...p,{id:"V"+Date.now(),placa:form.placa,modelo:form.modelo,ano:parseInt(form.ano||2024),cor:form.cor||"",km:parseInt(form.km||0),status:"disponivel",motorista:form.motorista||"",venc_cnh:form.venc_cnh||"",venc_seguro:form.venc_seguro||"",venc_ipva:form.venc_ipva||""}]); setModal(null); setForm({}); },
    manutencao: () => { if(!form.veiculo) return; setManut(p=>[{id:"M"+Date.now(),veiculo:form.veiculo,tipo:form.tipo||"Preventiva",data:new Date().toLocaleDateString("pt-BR"),km:parseInt(form.km||0),custo:parseFloat(form.custo||0),oficina:form.oficina||"",obs:form.obs||""},  ...p]); setModal(null); setForm({}); },
  };

  return (
    <div style={{display:"flex",height:"100vh",...S.page}}>
      <div style={S.sidebar}>
        <div style={{padding:"14px 13px",borderBottom:"1px solid #1E293B"}}>
          <div style={{fontSize:11,color:"#64748B"}}>ERP EMPRESA</div>
          <div style={{fontWeight:700,fontSize:13}}>{tenant?.empresa}</div>
          <div style={{fontSize:11,marginTop:2}}>
            <span style={{color:PLANOS.find(p=>p.id===tenant?.plano)?.cor||"#3B82F6",textTransform:"capitalize",fontWeight:600}}>{tenant?.plano}</span>
          </div>
        </div>
        <nav style={{flex:1,padding:"10px 7px",overflowY:"auto"}}>
          {MENUS.map(([id,ic,lb])=>(
            <div key={id} onClick={()=>setAba(id)} style={{...S.nav,background:aba===id?"#1E3A5F":"transparent",color:aba===id?"#3B82F6":"#94A3B8",fontWeight:aba===id?600:400}}>{ic} {lb}</div>
          ))}
        </nav>
        <div style={{padding:"10px 7px",borderTop:"1px solid #1E293B"}}>
          <div onClick={onBack} style={{...S.nav,color:"#64748B",fontSize:12}}>← Admin Geral</div>
        </div>
      </div>

      <div style={{flex:1,overflow:"auto",padding:24}}>

        {aba==="dashboard"&&(
          <div>
            <div style={{marginBottom:18}}><h1 style={{fontSize:20,fontWeight:800}}>{tenant?.empresa}</h1><div style={{color:"#64748B",fontSize:12}}>{new Date().toLocaleDateString("pt-BR",{weekday:"long",day:"2-digit",month:"long",year:"numeric"})}</div></div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Clientes ativos" valor={ativos} sub={clientes.length+" total"} c="#3B82F6" icon="👥"/>
              <Metric label="A receber" valor={fmt(rec_ab)} sub="Em aberto" c="#10B981" icon="💰"/>
              <Metric label="Contratos ativos" valor={ct_ativos} sub={contratos.length+" total"} c="#8B5CF6" icon="📋"/>
              <Metric label="Estoque crítico" valor={est_baixo} sub="abaixo do mínimo" c={est_baixo>0?"#EF4444":"#10B981"} icon="📦"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"3fr 2fr",gap:18}}>
              <Card>
                <div style={{fontWeight:700,marginBottom:12,display:"flex",justifyContent:"space-between"}}><span>Últimos lançamentos</span><Btn sm onClick={()=>setAba("financeiro")}>Ver todos</Btn></div>
                {cr.slice(0,5).map(r=>(
                  <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <div><div style={{fontSize:13,fontWeight:500}}>{r.desc}</div><div style={{fontSize:11,color:"#64748B"}}>{r.cliente} · {r.venc}</div></div>
                    <div style={{display:"flex",gap:10,alignItems:"center"}}>
                      <span style={{fontWeight:700,fontSize:13,color:r.status==="pago"?"#10B981":r.status==="atrasado"?"#EF4444":"#F1F5F9"}}>{fmt(r.valor)}</span>
                      <Badge status={r.status}/>
                    </div>
                  </div>
                ))}
              </Card>
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                <Card>
                  <div style={{fontWeight:700,marginBottom:10,fontSize:13}}>Veículos</div>
                  {[["disponivel","Disponíveis",vei_disp],["em_uso","Em uso",frota.filter(v=>v.status==="em_uso").length],["manutencao","Manutenção",frota.filter(v=>v.status==="manutencao").length]].map(([s,l,v])=>(
                    <div key={s} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #1E293B"}}>
                      <span style={{color:"#94A3B8",fontSize:12}}>{l}</span><span style={{fontWeight:700,color:cor(s)}}>{v}</span>
                    </div>
                  ))}
                  <Btn sm full onClick={()=>setAba("frota")} style={{marginTop:10}}>Gerenciar frota</Btn>
                </Card>
                <Card>
                  <div style={{fontWeight:700,marginBottom:10,fontSize:13}}>Estoque crítico</div>
                  {estoque.filter(e=>e.estoque<=e.minimo).slice(0,3).map(e=>(
                    <div key={e.id} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #1E293B"}}>
                      <span style={{color:"#94A3B8",fontSize:12,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.nome}</span>
                      <span style={{fontWeight:700,color:"#EF4444",fontSize:12}}>{e.estoque}/{e.minimo}</span>
                    </div>
                  ))}
                  {est_baixo===0&&<div style={{color:"#10B981",fontSize:12,textAlign:"center",padding:"8px 0"}}>✓ Tudo em dia!</div>}
                  <Btn sm full onClick={()=>setAba("estoque")} style={{marginTop:10}}>Ver estoque</Btn>
                </Card>
              </div>
            </div>
          </div>
        )}

        {aba==="clientes"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Clientes</h1><div style={{color:"#64748B",fontSize:12}}>{clientes.length} cadastrados · {ativos} ativos</div></div>
              <Btn onClick={()=>{setModal("cliente");setForm({nome:"",doc:"",email:"",tel:"",cidade:"",plano:"",tipo:"PF"});}}>+ Novo cliente</Btn>
            </div>
            {modal==="cliente"&&(
              <Modal title="Novo cliente" onClose={()=>setModal(null)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  {[["Nome completo","nome"],["CPF / CNPJ","doc"],["Email","email"],["Telefone","tel"],["Cidade","cidade"],["Plano contratado","plano"]].map(([l,k])=>(
                    <Campo key={k} label={l} value={form[k]||""} onChange={v=>f(k,v)}/>
                  ))}
                  <Campo label="Tipo" value={form.tipo||"PF"} onChange={v=>f("tipo",v)} options={["PF","PJ"]}/>
                </div>
                <Btn onClick={salvar.cliente} c="#10B981">✓ Salvar cliente</Btn>
              </Modal>
            )}
            <Card>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Nome","Doc","Email","Cidade","Plano","Status",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {clientes.map(c=>(
                    <tr key={c.id} style={{borderBottom:"1px solid #1E293B"}}>
                      <td style={{...S.td,fontWeight:600}}>{c.nome}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.doc}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.email}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.cidade}</td>
                      <td style={{...S.td,color:"#8B5CF6",fontSize:12}}>{c.plano}</td>
                      <td style={S.td}><Badge status={c.ativo?"ativo":"suspenso"}/></td>
                      <td style={S.td}><Btn sm out c="#64748B" onClick={()=>setClientes(p=>p.map(x=>x.id===c.id?{...x,ativo:!x.ativo}:x))}>{c.ativo?"Inativar":"Ativar"}</Btn></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          </div>
        )}

        {aba==="financeiro"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Financeiro</h1><div style={{color:"#64748B",fontSize:12}}>Contas a receber e a pagar</div></div>
              <Btn onClick={()=>{setModal("lancamento");setForm({desc:"",cliente:"",valor:"",venc:"",tipo:"CR"});}} c="#10B981">+ Novo lançamento</Btn>
            </div>
            {modal==="lancamento"&&(
              <Modal title="Novo lançamento" onClose={()=>setModal(null)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  {[["Descrição","desc"],["Cliente","cliente"],["Valor (R$)","valor"],["Vencimento","venc"]].map(([l,k])=>(
                    <Campo key={k} label={l} value={form[k]||""} onChange={v=>f(k,v)} type={k==="valor"?"number":k==="venc"?"date":"text"}/>
                  ))}
                  <Campo label="Tipo" value={form.tipo||"CR"} onChange={v=>f("tipo",v)} options={["CR - A Receber","CP - A Pagar"]}/>
                </div>
                <Btn onClick={salvar.lancamento} c="#10B981">✓ Salvar lançamento</Btn>
              </Modal>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="A receber" valor={fmt(rec_ab)} sub={cr.filter(x=>x.status==="aberto").length+" títulos"} c="#10B981" icon="📥"/>
              <Metric label="Atrasados" valor={fmt(rec_at)} sub="Urgente" c="#EF4444" icon="⏰"/>
              <Metric label="Recebido" valor={fmt(rec_pg)} sub="Quitados" c="#3B82F6" icon="✅"/>
            </div>
            <Card>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Descrição","Cliente","Valor","Vencimento","Status",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {cr.map(r=>(
                    <tr key={r.id} style={{borderBottom:"1px solid #1E293B"}}>
                      <td style={S.td}>{r.desc}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{r.cliente}</td>
                      <td style={{...S.td,fontWeight:700,color:r.status==="atrasado"?"#EF4444":"#F1F5F9"}}>{fmt(r.valor)}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{r.venc}</td>
                      <td style={S.td}><Badge status={r.status}/></td>
                      <td style={S.td}>{r.status!=="pago"&&<Btn sm c="#10B981" onClick={()=>setCr(p=>p.map(x=>x.id===r.id?{...x,status:"pago"}:x))}>Dar baixa</Btn>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          </div>
        )}

        {aba==="contratos"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Contratos</h1><div style={{color:"#64748B",fontSize:12}}>{contratos.length} contratos · {ct_ativos} ativos</div></div>
              <Btn onClick={()=>{setModal("contrato");setForm({cliente:"",plano:"",valor:"",inicio:"",fim:"",venc_dia:"10",obs:""});}}>+ Novo contrato</Btn>
            </div>
            {modal==="contrato"&&(
              <Modal title="Novo contrato" onClose={()=>setModal(null)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  {[["Cliente","cliente"],["Plano/Serviço","plano"],["Valor mensal (R$)","valor"],["Dia vencimento","venc_dia"],["Início","inicio"],["Término","fim"],["Observações","obs"]].map(([l,k])=>(
                    <Campo key={k} label={l} value={form[k]||""} onChange={v=>f(k,v)} type={k==="valor"?"number":k.includes("ini")||k.includes("fim")?"date":"text"}/>
                  ))}
                </div>
                <Btn onClick={salvar.contrato} c="#10B981">✓ Salvar contrato</Btn>
              </Modal>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Contratos ativos" valor={ct_ativos} c="#10B981" icon="📋"/>
              <Metric label="Suspensos" valor={contratos.filter(c=>c.status==="suspenso").length} c="#EF4444" icon="⏸️"/>
              <Metric label="Receita mensal" valor={fmt(contratos.filter(c=>c.status==="ativo").reduce((a,c)=>a+c.valor,0))} c="#3B82F6" icon="💰"/>
            </div>
            <Card>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Número","Cliente","Plano","Valor","Início","Término","Venc.","Status",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {contratos.map(c=>(
                    <tr key={c.id} style={{borderBottom:"1px solid #1E293B"}}>
                      <td style={{...S.td,color:"#3B82F6",fontWeight:600,fontSize:12}}>{c.numero}</td>
                      <td style={{...S.td,fontWeight:600}}>{c.cliente}</td>
                      <td style={{...S.td,color:"#8B5CF6",fontSize:12}}>{c.plano}</td>
                      <td style={{...S.td,fontWeight:700,color:"#10B981"}}>{fmt(c.valor)}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.inicio}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{c.fim}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>dia {c.venc_dia}</td>
                      <td style={S.td}><Badge status={c.status}/></td>
                      <td style={S.td}>
                        <Btn sm out c="#EF4444" onClick={()=>setContratos(p=>p.map(x=>x.id===c.id?{...x,status:x.status==="ativo"?"suspenso":"ativo"}:x))}>
                          {c.status==="ativo"?"Suspender":"Ativar"}
                        </Btn>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          </div>
        )}

        {aba==="estoque"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Estoque</h1><div style={{color:"#64748B",fontSize:12}}>{estoque.length} produtos · {est_baixo} abaixo do mínimo</div></div>
              <Btn onClick={()=>{setModal("estoque_mov");setForm({produto:estoque[0]?.nome||"",tipo:"entrada",qtd:"",motivo:"",resp:""});}}>+ Movimentação</Btn>
            </div>
            {modal==="estoque_mov"&&(
              <Modal title="Movimentação de estoque" onClose={()=>setModal(null)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  <Campo label="Produto" value={form.produto||""} onChange={v=>f("produto",v)} options={estoque.map(e=>e.nome)}/>
                  <Campo label="Tipo" value={form.tipo||"entrada"} onChange={v=>f("tipo",v)} options={["entrada","saida"]}/>
                  <Campo label="Quantidade" value={form.qtd||""} onChange={v=>f("qtd",v)} type="number"/>
                  <Campo label="Responsável" value={form.resp||""} onChange={v=>f("resp",v)}/>
                  <div style={{gridColumn:"1/-1"}}><Campo label="Motivo" value={form.motivo||""} onChange={v=>f("motivo",v)}/></div>
                </div>
                <Btn onClick={salvar.estoque_mov} c="#10B981">✓ Registrar movimentação</Btn>
              </Modal>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Total produtos" valor={estoque.length} c="#3B82F6" icon="📦"/>
              <Metric label="Estoque crítico" valor={est_baixo} sub="abaixo do mínimo" c={est_baixo>0?"#EF4444":"#10B981"} icon="⚠️"/>
              <Metric label="Valor em estoque" valor={fmt(estoque.reduce((a,e)=>a+e.estoque*e.custo,0))} c="#8B5CF6" icon="💎"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"3fr 2fr",gap:18}}>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>Produtos</div>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Código","Nome","Categoria","Estoque","Mínimo","Custo","Preço",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {estoque.map(e=>(
                      <tr key={e.id} style={{borderBottom:"1px solid #1E293B"}}>
                        <td style={{...S.td,color:"#64748B",fontSize:12}}>{e.codigo}</td>
                        <td style={{...S.td,fontWeight:600,fontSize:13}}>{e.nome}</td>
                        <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{e.categoria}</td>
                        <td style={{...S.td,fontWeight:700,color:e.estoque<=e.minimo?"#EF4444":"#10B981"}}>{e.estoque} {e.unidade}</td>
                        <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{e.minimo}</td>
                        <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{fmt(e.custo)}</td>
                        <td style={{...S.td,fontWeight:600}}>{fmt(e.preco)}</td>
                        <td style={S.td}>{e.estoque<=e.minimo&&<span style={{color:"#EF4444",fontSize:11,fontWeight:700}}>⚠️ Baixo</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Card>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>Últimas movimentações</div>
                {movs.slice(0,6).map(m=>(
                  <div key={m.id} style={{padding:"8px 0",borderBottom:"1px solid #1E293B"}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}>
                      <span style={{fontSize:12,fontWeight:600,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.produto}</span>
                      <span style={{color:cor(m.tipo),fontWeight:700,fontSize:12}}>{m.tipo==="entrada"?"+":"-"}{m.qtd}</span>
                    </div>
                    <div style={{color:"#64748B",fontSize:11}}>{m.data} · {m.motivo}</div>
                  </div>
                ))}
              </Card>
            </div>
          </div>
        )}

        {aba==="frota"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div><h1 style={{fontSize:20,fontWeight:800}}>Frota</h1><div style={{color:"#64748B",fontSize:12}}>{frota.length} veículos · {vei_disp} disponíveis</div></div>
              <div style={{display:"flex",gap:10}}>
                <Btn sm out c="#F59E0B" onClick={()=>{setModal("manutencao");setForm({veiculo:frota[0]?frota[0].placa+" "+frota[0].modelo:"",tipo:"Preventiva",km:"",custo:"",oficina:"",obs:""});}}>+ Manutenção</Btn>
                <Btn onClick={()=>{setModal("veiculo");setForm({placa:"",modelo:"",ano:"",cor:"",km:"",motorista:"",venc_cnh:"",venc_seguro:"",venc_ipva:""});}}>+ Veículo</Btn>
              </div>
            </div>
            {modal==="veiculo"&&(
              <Modal title="Cadastrar veículo" onClose={()=>setModal(null)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  {[["Placa","placa"],["Modelo","modelo"],["Ano","ano"],["Cor","cor"],["KM atual","km"],["Motorista","motorista"],["Venc. CNH","venc_cnh"],["Venc. Seguro","venc_seguro"],["Venc. IPVA","venc_ipva"]].map(([l,k])=>(
                    <Campo key={k} label={l} value={form[k]||""} onChange={v=>f(k,v)} type={k==="km"||k==="ano"?"number":"text"}/>
                  ))}
                </div>
                <Btn onClick={salvar.veiculo} c="#10B981">✓ Salvar veículo</Btn>
              </Modal>
            )}
            {modal==="manutencao"&&(
              <Modal title="Registrar manutenção" onClose={()=>setModal(null)}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  <Campo label="Veículo" value={form.veiculo||""} onChange={v=>f("veiculo",v)} options={frota.map(v=>v.placa+" "+v.modelo)}/>
                  <Campo label="Tipo" value={form.tipo||"Preventiva"} onChange={v=>f("tipo",v)} options={["Preventiva","Corretiva","Revisão","Pneus"]}/>
                  <Campo label="KM atual" value={form.km||""} onChange={v=>f("km",v)} type="number"/>
                  <Campo label="Custo (R$)" value={form.custo||""} onChange={v=>f("custo",v)} type="number"/>
                  <Campo label="Oficina" value={form.oficina||""} onChange={v=>f("oficina",v)}/>
                  <div style={{gridColumn:"1/-1"}}><Campo label="Observações" value={form.obs||""} onChange={v=>f("obs",v)}/></div>
                </div>
                <Btn onClick={salvar.manutencao} c="#10B981">✓ Salvar manutenção</Btn>
              </Modal>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:18}}>
              <Metric label="Disponíveis" valor={vei_disp} c="#10B981" icon="🚗"/>
              <Metric label="Em uso" valor={frota.filter(v=>v.status==="em_uso").length} c="#3B82F6" icon="🔑"/>
              <Metric label="Manutenção" valor={frota.filter(v=>v.status==="manutencao").length} c="#F59E0B" icon="🔧"/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"3fr 2fr",gap:18}}>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>Veículos</div>
                <table style={{width:"100%",borderCollapse:"collapse"}}>
                  <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Placa","Modelo","Ano","KM","Motorista","Seguro","IPVA","Status",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {frota.map(v=>(
                      <tr key={v.id} style={{borderBottom:"1px solid #1E293B"}}>
                        <td style={{...S.td,fontWeight:700,color:"#3B82F6"}}>{v.placa}</td>
                        <td style={{...S.td,fontWeight:600}}>{v.modelo}</td>
                        <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{v.ano}</td>
                        <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{v.km.toLocaleString("pt-BR")} km</td>
                        <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{v.motorista||"—"}</td>
                        <td style={{...S.td,fontSize:12}}>{v.venc_seguro}</td>
                        <td style={{...S.td,fontSize:12}}>{v.venc_ipva}</td>
                        <td style={S.td}><Badge status={v.status}/></td>
                        <td style={S.td}>
                          <select value={v.status} onChange={e=>setFrota(p=>p.map(x=>x.id===v.id?{...x,status:e.target.value}:x))} style={{background:"#0F172A",border:"1px solid #334155",borderRadius:6,padding:"4px 8px",color:"#F1F5F9",fontSize:12,cursor:"pointer"}}>
                            <option value="disponivel">Disponível</option>
                            <option value="em_uso">Em uso</option>
                            <option value="manutencao">Manutenção</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Card>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>Últimas manutenções</div>
                {manut.slice(0,5).map(m=>(
                  <div key={m.id} style={{padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}>
                      <span style={{fontSize:12,fontWeight:600}}>{m.veiculo.split(" ").slice(0,2).join(" ")}</span>
                      <span style={{color:"#EF4444",fontWeight:700,fontSize:12}}>{fmt(m.custo)}</span>
                    </div>
                    <div style={{color:"#8B5CF6",fontSize:11,marginBottom:2}}>{m.tipo} · {m.data}</div>
                    <div style={{color:"#64748B",fontSize:11}}>{m.obs}</div>
                  </div>
                ))}
                <div style={{marginTop:12,paddingTop:10,borderTop:"1px solid #334155",display:"flex",justifyContent:"space-between"}}>
                  <span style={{color:"#94A3B8",fontSize:12}}>Total gasto</span>
                  <span style={{fontWeight:700,color:"#EF4444"}}>{fmt(manut.reduce((a,m)=>a+m.custo,0))}</span>
                </div>
              </Card>
            </div>
          </div>
        )}

        {aba==="relatorios"&&(
          <div>
            <h1 style={{fontSize:20,fontWeight:800,marginBottom:20}}>Relatórios</h1>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:18}}>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>📊 Resumo Financeiro</div>
                {[["Receita total (aberto)",fmt(rec_ab),"#10B981"],["Inadimplência",fmt(rec_at),"#EF4444"],["Recebido no mês",fmt(rec_pg),"#3B82F6"],["Receita contratos",fmt(contratos.filter(c=>c.status==="ativo").reduce((a,c)=>a+c.valor,0)),"#8B5CF6"]].map(([l,v,c])=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <span style={{color:"#94A3B8",fontSize:13}}>{l}</span><span style={{fontWeight:700,color:c}}>{v}</span>
                  </div>
                ))}
              </Card>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>👥 Resumo Clientes</div>
                {[["Total cadastrados",clientes.length,"#F1F5F9"],["Ativos",ativos,"#10B981"],["Inativos",clientes.length-ativos,"#EF4444"],["Contratos ativos",ct_ativos,"#3B82F6"]].map(([l,v,c])=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <span style={{color:"#94A3B8",fontSize:13}}>{l}</span><span style={{fontWeight:700,color:c}}>{v}</span>
                  </div>
                ))}
              </Card>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>📦 Resumo Estoque</div>
                {[["Total produtos",estoque.length,"#F1F5F9"],["Itens críticos",est_baixo,"#EF4444"],["Valor em estoque",fmt(estoque.reduce((a,e)=>a+e.estoque*e.custo,0)),"#8B5CF6"],["Movimentações",movs.length,"#3B82F6"]].map(([l,v,c])=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <span style={{color:"#94A3B8",fontSize:13}}>{l}</span><span style={{fontWeight:700,color:c}}>{v}</span>
                  </div>
                ))}
              </Card>
              <Card>
                <div style={{fontWeight:700,marginBottom:14}}>🚗 Resumo Frota</div>
                {[["Total veículos",frota.length,"#F1F5F9"],["Disponíveis",vei_disp,"#10B981"],["Em uso",frota.filter(v=>v.status==="em_uso").length,"#3B82F6"],["Custo manutenção",fmt(manut.reduce((a,m)=>a+m.custo,0)),"#EF4444"]].map(([l,v,c])=>(
                  <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid #1E293B"}}>
                    <span style={{color:"#94A3B8",fontSize:13}}>{l}</span><span style={{fontWeight:700,color:c}}>{v}</span>
                  </div>
                ))}
              </Card>
            </div>
          </div>
        )}

        {aba==="usuarios"&&(
          <div>
            <h1 style={{fontSize:20,fontWeight:800,marginBottom:20}}>Usuários</h1>
            <Card>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:"1px solid #334155"}}>{["Nome","Email","Perfil","Status","Último acesso",""].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {[{nome:"Marcelo Paziani",email:"marcelo@maisveloz.com.br",perfil:"Administrador",status:"ativo",acesso:"Hoje 05:30"},
                    {nome:"Carlos Técnico",email:"carlos@maisveloz.com.br",perfil:"Operacional",status:"ativo",acesso:"Hoje 04:15"},
                    {nome:"Pedro Instalador",email:"pedro@maisveloz.com.br",perfil:"Técnico",status:"ativo",acesso:"Ontem 18:42"},
                    {nome:"Ana Financeiro",email:"ana@maisveloz.com.br",perfil:"Financeiro",status:"ativo",acesso:"Hoje 03:00"},
                  ].map((u,i)=>(
                    <tr key={i} style={{borderBottom:"1px solid #1E293B"}}>
                      <td style={{...S.td,fontWeight:600}}>{u.nome}</td>
                      <td style={{...S.td,color:"#94A3B8",fontSize:12}}>{u.email}</td>
                      <td style={{...S.td}}><span style={{background:"#3B82F622",color:"#3B82F6",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{u.perfil}</span></td>
                      <td style={S.td}><Badge status={u.status}/></td>
                      <td style={{...S.td,color:"#64748B",fontSize:12}}>{u.acesso}</td>
                      <td style={S.td}><Btn sm out c="#64748B">Editar</Btn></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{marginTop:14}}><Btn c="#3B82F6">+ Novo usuário</Btn></div>
            </Card>
          </div>
        )}

      </div>
    </div>
  );
}

// ── APP ──────────────────────────────────────────────────────────────────────
export default function App() {
  const [tela,setTela] = useState("landing");
  const [tenant,setTenant] = useState(null);
  if(tela==="landing") return <Landing onGo={()=>setTela("login")}/>;
  if(tela==="login") return <Login onLogin={m=>{setTela(m==="admin"?"admin":"tenant");if(m==="tenant")setTenant(TENANTS_INIT[0]);}}/>;
  if(tela==="admin") return <Admin onLogout={()=>setTela("landing")} onTenant={t=>{setTenant(t);setTela("tenant");}}/>;
  if(tela==="tenant") return <TenantERP tenant={tenant} onBack={()=>setTela("admin")}/>;
}
